const wineList = [
  'assyrtiko',
  'moschofilero',
  'muscadet',
  'viognier',
  'verdicchio',
  'white burgundy',
  'chardonnay',
  'gruener veltliner',
  'frascati',
  'gavi',
  'trebbiano',
  'sauvignon blanc',
  'albarino',
  'verdejo',
  'pinot grigio',
  'gewurztraminer',
  'chenin blanc',
  'riesling',
  'zweigelt',
  'barbera wine',
  'primitivo',
  'pinot noir',
  'nebbiolo',
  'red burgundy',
  'rioja',
  'grenache',
  'malbec',
  'zinfandel',
  'sangiovese',
  'cabernet sauvignon',
  'tempranillo',
  'shiraz',
  'merlot',
  "nero d'avola",
  'bordeaux',
  'port',
  'gamay',
  'dornfelder',
  'pinotage',
  'agiorgitiko',
  'dessert wine',
  'moscato',
  'cava',
  'champagne',
  'sherry',
  'cream sherry',
  'dry sherry'
];

export default wineList;
